import { useEffect, useState, useContext , useRef } from "react";
import toast from "react-hot-toast";
import PaymentTable from "./components/PaymentsList";
import { getAllPayments  } from "api/payments";
import { getAllClients } from "api/clients";
import { ClientContext } from "ClientProvider";
// import { getSingleRole } from "api/role";
import { getSingleRole } from "api/graphQL_role";
// import { getAllGatewaysSecond } from "api/gateways";
import { getAllGatewaysSecond } from "api/graphQL_gateways";
import {  getCardType } from "api/graphQL_payments";
import { getId } from "utils/auth";
import { getAllPayouts, getPayoutsFilter } from "api/payouts";
import BatchPayout from "views/admin/batch/payout"

export type PaymentRowObj = {
  id: string;
  payment_id: string;
  et_id: string;
  amount: string;
  currency: string;
  gateway_id: string;
  gateway_name: string;
  status: string;
  meta_info: any;
  gateway_response: any;
  payment_type: string;
  client: string;
  refund_info: string;
  created_at: string;
  image: string;
  all_data: any[];
  expanded: boolean;
  payment_history: any;
};

const Payouts = () => {
  const [payments, setPayments] = useState<PaymentRowObj[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [page, setPage] = useState<number>(0);
  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [clients, setClients] = useState();
  const [value, setValue] = useState(false);
  const [curretClient, setCurrentClient] = useState<string>("all");
  const [allGateways, setAllGateways] = useState();
  const [allCardType, setCardType] = useState();
  const [searchTexts, setSearchTexts] = useState<string>("");
  const [localFilters, setLocalFilters] = useState<any>({});
  const [clearClicked,setClearClick] = useState(0)
  const [isPaymentLoading, setIsPaymentLoading] = useState<boolean>();
  const { activeTab, setActiveTab } = useContext(ClientContext);
  const { paymentType, singleRoleData, setSingleRoleData, filter, setFilter, setLoadingTransaction , loadingTransaction } = useContext(ClientContext);
useEffect(() => {
    setFilter({});
  }, []);

  const [loadingState, setLoadingState] = useState({
    clients: true,
    gateways: true,
    cardTypes: true,
  });
  const hasSinglePayoutPermission =
  singleRoleData?.[0]?.payout?.value?.view_payout_list;
const hasBatchPayoutPermission =
  singleRoleData?.[0]?.payout?.value?.view_batch_payout;
  const apiCalledRef = useRef(false);

  const fetchClients = () => {
    // setIsLoading(true);
    getAllClients()
      .then((data) => {
        setClients(data);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ??
          "Something went wrong while fetching clients"
        );
      })
      .finally(() => {
        // setIsLoading(false);
        setLoadingState(prev => ({ ...prev, clients: false }));
      });
  };
  const fetchAllGateways = () => {
    // setIsLoading(true);
    getAllGatewaysSecond()
      .then((data) => {
        setAllGateways(data);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ??
          "Something went wrong while fetching AllGateways"
        );
      })
      .finally(() => {
        // setIsLoading(false);
        setLoadingState(prev => ({ ...prev, gateways: false }));
      });
  };

  const fetchCardType = () => {
    // setIsLoading(true);
    getCardType()
      .then((data) => {
        setCardType(data);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ??
          "Something went wrong while fetching CardType"
        );
      })
      .finally(() => {
        // setIsLoading(false);
        setLoadingState(prev => ({ ...prev, cardTypes: false }));
      });
  };

  const fetchRole = () => {
    // setIsLoading(true);
    getSingleRole(getId())
      .then((data) => {
        setSingleRoleData(data ?? []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ??
          "Something went wrong while fetching role"
        );
      })
      .finally(() => {
        // setIsLoading(false);
      });
  };

  useEffect(() => {
    // fetchPayments()
    fetchClients()
    fetchAllGateways();
    fetchCardType();
  }, []);

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt);
      setPage(1);
    } else {
      await setSearchTexts(search_txt);
    }
  };
  const filterData = async () => {
    const paymentType = filter?.status;
    const client = filter?.client;
    const gateway = filter?.gateway;
    const payment_status = filter?.payment_status;
    const card_type = filter?.card_type;
    const start_date = filter?.dates?.[0];
    const end_date = filter?.dates?.[1];
    const timezone = filter?.timezone;

    setIsPaymentLoading(true);
    setPayments([]);
    setLoadingTransaction(true)
    try {
      const data = await getPayoutsFilter(
        page,
        pageSize,
        paymentType,
        client,
        gateway,
        card_type,
        payment_status,
        timezone,
        start_date,
        searchTexts,
        end_date
      );

      setPayments(
        Object.entries(data.payments ?? {}).map(([key, value]: any) => ({
          ...value[0],
          payment_id: key,
          expanded: false,
          all_data: value,
        }))
      );

      setTotalPage(data.total_pages);
      setTotalItems(data.total_items);
      setCurrentPage(data.current_page);
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ??
          "Something went wrong while fetching payouts"
      );
    } finally {
      setIsPaymentLoading(false);
      setLoadingTransaction(false)
    }
  };

  // useEffect(() => {
  //   if (page == 0) {
  //   } else {
  //     filterData();
  //   }
  // }, [page, curretClient, pageSize, value,clearClicked,activeTab]);

  useEffect(() => {
    if (page === 0) return;

    // if (apiCalledRef.current) return;
    // apiCalledRef.current = true;

    filterData();
  }, [page, curretClient, pageSize, clearClicked, activeTab,searchTexts,filter?.status]);
 

  useEffect(() => {
    apiCalledRef.current = false;
    setPage(1);
    // setPageSize(50);
    setValue(!value);
  }, [paymentType,filter?.status, searchTexts, activeTab]);

const onClearClick = () => {
    setPage(1);
    setPageSize(50);
    setClearClick((prev) => {
      const newCount = prev + 1;
      return newCount;
    });
  };

  const isAllDataReady = Object.values(loadingState).every(v => v === false);

  return (
    <>
      <div className="w-full  mx-auto mt-5 pt-5">
        {hasSinglePayoutPermission && hasBatchPayoutPermission ? (
          <>
            <div className="relative flex w-1/3 bg-gray-100 dark:bg-gray-800 p-1 rounded-2xl shadow-inner  mb-2">
              <div
                className="absolute top-1 bottom-1 w-[49.1%] transition-all duration-300 ease-out rounded-2xl bg-white dark:bg-gray-700"
                style={{
                  transform: activeTab === "single" ? "translateX(0%)" : "translateX(100%)",
                  boxShadow: '0 4px 14px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)',
                }}
              ></div>
              <button
                onClick={() => { setActiveTab("single"); setFilter({}); }}
                className={`relative z-10 w-1/2 text-sm font-semibold py-3 transition-colors duration-300 rounded-2xl ${
                  activeTab === "single"
                    ? "text-indigo-600 dark:text-indigo-400"
                    : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
                }`}
              >
                Single Payout
              </button>
              <button
                onClick={() => setActiveTab("batch")}
                className={`relative z-10 w-1/2 text-sm font-semibold py-3 transition-colors duration-300 rounded-2xl ${
                  activeTab === "batch"
                    ? "text-indigo-600 dark:text-indigo-400"
                    : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
                }`}
              >
                Batch Payout
              </button>
            </div>
    
            <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-2xl shadow-lg p-6 transition-all duration-300">
              {activeTab === "single" && (
                <PaymentTable
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  tableData={payments}
                  fetchPayments={filterData}
                  isLoading={isPaymentLoading}
                  page={page}
                  setPage={setPage}
                  totalpage={totalpage}
                  totalItems={totalItems}
                  currentPage={currentPage}
                  clients={clients}
                  allGateways={allGateways}
                  allCardType={allCardType}
                  curretClient={curretClient}
                  setCurrentClient={setCurrentClient}
                  roleData={singleRoleData}
                  filterData={filterData}
                  setClearClick={onClearClick}
                  filter={filter}
                  setFilter={setFilter}
                  onValueChange={serchboxValueChange}
                  setLocalFilters={setLocalFilters}
                  isAllDataReady={isAllDataReady}
                />
              )}

              {activeTab === "batch" && <BatchPayout />}
            </div>
            </>
        ) : hasSinglePayoutPermission ? (
          <div className="mt-5 pt-5">
            <PaymentTable
              pageSize={pageSize}
              setPageSize={setPageSize}
              tableData={payments}
              fetchPayments={filterData}
              isLoading={isPaymentLoading}
              page={page}
              setPage={setPage}
              totalpage={totalpage}
              totalItems={totalItems}
              currentPage={currentPage}
              clients={clients}
              allGateways={allGateways}
              allCardType={allCardType}
              curretClient={curretClient}
              setCurrentClient={setCurrentClient}
              roleData={singleRoleData}
              filterData={filterData}
              setClearClick={onClearClick}
              filter={filter}
              setFilter={setFilter}
              onValueChange={serchboxValueChange}
              setLocalFilters={setLocalFilters}
              isAllDataReady={isAllDataReady}
            />
          </div>
          ) : hasBatchPayoutPermission ? (
            <BatchPayout />
          ) : (
            <></>
          )}
      </div>
    </>
  );
};

export default Payouts;
